import { Category } from '~/commons/interfaces/models/content/category/Category'
import { getCategoryCustomField, isValueEnabled } from '~/helpers'

export function isCategoryCustomFieldEnabled(
  category: Category,
  key: string
): boolean {
  return isValueEnabled(getCategoryCustomField(category, key))
}
